import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { PlateListMaintenanceDto } from './PlateListMaintenanceDto';
import { PlateItemMaintenanceDto } from './PlateItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';

@Injectable()
export class PlateMaintenanceController extends BaseMaintenanceController<PlateListMaintenanceDto, PlateItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "plate");
    }


    public getResourceRoot(): string {
        return "PLATE";
    }

    public buildUrl(uri: string): string {
        return "/activity/plate" + uri;
    }
}
